export default "__VITE_ASSET__CpqueXZ4__"